module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.LoginShow) ? _c('div', {
    attrs: {
      "id": "Login"
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.keydownLoading),
      expression: "keydownLoading"
    }],
    staticClass: "KeyEnterLoading"
  }, [_c('div', {
    staticClass: "mask-one"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h3', {
    staticClass: "clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "close-img",
    on: {
      "click": _vm.closeLogin
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/getz_push_close.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "searchInputWrappe"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    ref: "input",
    class: {
      active: _vm.changing
    },
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "placeholder": "Instagram username (not email, no password required)",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keyEnterFun($event)
      }, _vm.onKeyUp],
      "focus": _vm.hideLogo,
      "blur": _vm.showLogo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clearShow),
      expression: "clearShow"
    }],
    on: {
      "click": _vm.emptyInput
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/getz_searchfriendsbox_close.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "confirm-button",
    class: {
      active: _vm.searchInput != '' && _vm.confirmOnoff == false
    },
    attrs: {
      "disabled": _vm.confirmOnoff
    },
    on: {
      "click": _vm.clickConfirm
    }
  }, [_c('span', [_vm._v("Get Started")])]), _vm._v(" "), _c('div', {
    staticClass: "please"
  }, [_c('p', [_c('span', [_vm._v("Please make sure you aren't using a private profile. ")]), _c('a', {
    on: {
      "click": _vm.detailShow
    }
  }, [_vm._v("See more >>")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomLogo),
      expression: "bottomLogo"
    }],
    staticClass: "bottom-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/image_logo@3x(5).png"),
      "alt": ""
    }
  })])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "LoadingMid"
  }, [_c('div', {
    staticClass: "sk-fading-circle"
  }, [_c('div', {
    staticClass: "sk-circle1 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle2 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle3 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle4 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle5 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle6 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle7 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle8 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle9 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle10 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle11 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle12 sk-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "title-inner"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/icon/image_instagram_icon@3x.png"),
      "alt": ""
    }
  }), _c('i', [_vm._v("Enter your Instagram username")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72d6598a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Login.vue
// module id = 270
// module chunks = 18